var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAgent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 22,
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 22,
  fill: "transparent"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.8 12.6923C18.8 12.8558 18.6594 13 18.5 13H11H3.5C3.34063 13 3.2 12.8558 3.2 12.6923V4.53846C3.2 4.375 3.34063 4.23077 3.5 4.23077H18.5C18.6594 4.23077 18.8 4.375 18.8 4.53846V12.6923ZM20 4.53846C20 3.69231 19.325 3 18.5 3H3.5C2.675 3 2 3.69231 2 4.53846V15C2 15.8462 2.675 16.5385 3.5 16.5385H8.6C8.6 17.375 8 18.0288 8 18.3846C8 18.7212 8.27188 19 8.6 19H13.4C13.7281 19 14 18.7212 14 18.3846C14 18.0481 13.4 17.3558 13.4 16.5385H18.5C19.325 16.5385 20 15.8462 20 15V4.53846Z"
})));
export default SvgAgent;